// CardSkeleton.js — Esqueleto do card de livro, exibido enquanto o catálogo carrega.
//
// Existe para matar o salto de layout: antes, /livros mostrava a frase
// "Carregando..." (uma linha de texto) e, quando os dados chegavam, a página
// inteira pulava para acomodar a grade. O esqueleto ocupa exatamente o mesmo
// espaço do card real — mesma proporção 3:4 de capa, mesmas alturas de texto —
// então a chegada dos livros não move nada de lugar.
import React from "react";

const CardSkeleton = () => (
  <div className="p-3 animate-pulse" aria-hidden="true">
    <div className="rounded-lg bg-insigne-navy-soft aspect-[3/4]" />
    <div className="mt-3.5 px-1">
      <div className="h-4 rounded bg-insigne-navy-soft" />
      <div className="h-4 w-2/3 rounded bg-insigne-navy-soft mt-2" />
      <div className="h-3 w-1/2 rounded bg-insigne-navy-soft mt-3" />
      {/* A linha do preço antigo, que o card reserva mesmo sem desconto. */}
      <div className="h-3 w-14 rounded bg-insigne-navy-soft mt-3" />
      <div className="h-6 w-24 rounded bg-insigne-navy-soft mt-1" />
      {/* A linha do preço do impresso, também reservada no card real. */}
      <div className="h-3 w-20 rounded bg-insigne-navy-soft mt-2" />
      <div className="h-9 rounded-controle bg-insigne-navy-soft mt-3" />
    </div>
  </div>
);

/** Grade de N esqueletos com as mesmas colunas do catálogo. */
export const GradeSkeleton = ({ quantidade = 12, className = "" }) => (
  <div className={"grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-6 " + className}>
    {Array.from({ length: quantidade }).map((_, i) => (
      <CardSkeleton key={i} />
    ))}
  </div>
);

export default CardSkeleton;
